import Type1 from "./packingMenuType1";

export default Type1;
